import React from 'react';
import { Spacing } from 'works/legacy/lib/style-helper';
import { TextFilterSearch } from '@common/components';
import { FilterDropdownProps } from 'antd/lib/table/interface';

export function TextSearchTableFilter({
  setSelectedKeys,
  confirm,
}: FilterDropdownProps) {
  return (
    <section style={{ padding: `${Spacing.baseSpacing / 2}px` }}>
      <TextFilterSearch
        onSearch={(value) => {
          value ? setSelectedKeys([value]) : setSelectedKeys([]);
          confirm();
        }}
      />
    </section>
  );
}
